<template>
  <transition name="fade" appear appear-active-class="fade-into">
    <div v-if="imgLarge" class="img-view" @click="bigImg">
      <!-- 遮罩层 -->
      <div class="img-layer"></div>
      <div class="img">
        <img :src="imgSrc" />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "VdmLargeImg",
  props: {
    imgSrc: {
      type: String,
      default: "",
    },
    imgLarge: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    bigImg() {
      this.$emit("bigImg");
    },
  },
};
</script>

<style lang="scss" scoped>
.img-view {
  position: relative;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

/*遮罩层样式*/
.img-view .img-layer {
  position: absolute;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  overflow: hidden;
}

/*不限制图片大小，实现居中*/
.img-view .img img {
  width: 80%;
  height: 80%;
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 1000;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.fade-into {
    transition: all .5s;
    opacity: 1;
}
</style>